import { useState } from "react";
import styled from "styled-components";
import { MdMyLocation } from "react-icons/md";

const mapUrl =
  "https://www.openstreetmap.org/export/embed.html?bbox=28.85573%2C47.04212%2C28.86143%2C47.04362&layer=mapnik&marker=47.04287%2C28.85858";

const StyledMap = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 260px;
  overflow: hidden;
  border: 1px solid rgba(220, 226, 230, 0.12);
  border-radius: 22px;
  background: #101b28;

  iframe {
    display: block;
    width: 100%;
    height: 100%;
    min-height: 260px;
    border: 0;
  }
`;

const StyledResetButton = styled.button`
  position: absolute;
  z-index: 2;
  top: 12px;
  left: 12px;
  min-height: 38px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 12px;
  border: 1px solid rgba(220, 226, 230, 0.24);
  border-radius: 999px;
  background: rgba(8, 15, 23, 0.9);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.26);
  color: #f0ece5;
  font-family: Roboto-Regular;
  font-size: 12px;
  letter-spacing: 0.02em;
  cursor: pointer;
  backdrop-filter: blur(10px);
  transition:
    background 160ms ease,
    transform 160ms ease;

  &:hover {
    background: rgba(20, 33, 47, 0.96);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  svg {
    flex: 0 0 auto;
    font-size: 17px;
  }

  @media (max-width: 420px) {
    top: 10px;
    left: 10px;
    min-height: 36px;
    padding: 7px 10px;
  }
`;

export const Map = () => {
  const [mapRevision, setMapRevision] = useState(0);

  return (
    <StyledMap>
      <iframe
        key={mapRevision}
        src={mapUrl}
        title="Essencebit at 1/E Bogdan Voievod, Chișinău, Moldova"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        allowFullScreen
      />
      <StyledResetButton
        type="button"
        aria-label="Reset map position and zoom"
        onClick={() => setMapRevision((revision) => revision + 1)}
      >
        <MdMyLocation aria-hidden="true" />
        Reset view
      </StyledResetButton>
    </StyledMap>
  );
};
